
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="py-20 md:py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif text-primary-dark mb-6 md:mb-8 leading-tight">
            Des solutions <span className="text-primary">sur mesure</span> pour votre activité
          </h1>
          <p className="text-base md:text-xl lg:text-2xl text-gray-dark font-light leading-relaxed mb-8 md:mb-12">
            Que vous soyez artisan, dirigeant de TPE/PME, libéral, micro-entrepreneur ou cadre, accédez à des solutions d'accompagnement, de formation et de développement adaptées à vos besoins professionnels.
          </p>
          <Link
            to="/formulaire"
            className="inline-flex items-center gap-3 bg-primary text-white px-8 md:px-12 py-3.5 md:py-5 rounded-full text-base md:text-lg font-semibold hover:bg-primary-dark transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Rejoindre le réseau
            <i className="ri-arrow-right-line text-lg md:text-xl"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
